'use strict';

const Cookies = require('js-cookie');


class CookieMessage {

    constructor() {
        // merge defaults with options
        this.options = {
            varName: 'cookieSettings',
            templateId: 'dbk-cookie-message-tmpl',
            elementId: 'dbk-cookie-overlay-v2',
            cookies: {
                name: 'dbk_cookie_settings',
                google_consent_name: 'dbk_tagging_consent',
                lifetime: 365,
            },
            settings: {
                necessary: 1,
                functional: 0,
                analytical: 0,
                tracking: 0,
            },
        }

        this.cookies = Cookies.withConverter({
            read: function (value, name) {
                return value;
            },
            write: function (value, name) {
                return value;
            }
        })

        this.initGoogleConsentMode();

        if (this.hasCookie()) {
            this.loadCookieSettings();
        } else {
            this.loadDefaultSettings();
            document.addEventListener('DOMContentLoaded', (event) => {
                this.initCookieMessage();
            });
        }
    }

    // Add required code for Google Consent Mode V2
    initGoogleConsentMode() {
        this.consentListeners = [];

        // add callback function for Google Tag Manager to call when consent mode initializes
        // GTM will call this function to add listeners
        window.DBKconsentListener = (callback) => {
            this.consentListeners.push(callback);
        };
    }

    // call onConsentChange to send consent states to Google Consent Mode API
    onConsentChange(consent) {
        this.consentListeners.forEach((callback) => {
            callback(consent)
        });

        if (window.dataLayer) {
            window.dataLayer.push({
                'event': 'cookiePref_save',
                'data': this.settings
            });
        }
    }

    loadDefaultSettings() {
        this.setSettings(this.options.settings);
        this.setCheckboxes(this.options.checkboxes);
    }

    loadCookieSettings() {
        var settings = this.getCookieSettings();
        this.setSettings(settings);
        this.setCheckboxes(settings);
    }

    hasCookie() {
        return typeof this.cookies.getJSON(this.options.cookies.name) !== 'undefined';
    }

    getCookieSettings() {
        return this.cookies.getJSON(this.options.cookies.name);
    }

    setCheckboxes(checkboxes) {
        this.checkboxes = checkboxes;
    }

    setSettings(settings) {
        this.settings = settings;
    }

    saveSettings() {
        const consentSettings = {
            'ad_storage': this.settings.analytical ? 'granted' : 'denied',
            'ad_user_data': this.settings.analytical ? 'granted' : 'denied',
            'ad_personalization': this.settings.tracking ? 'granted' : 'denied',
            'analytics_storage': this.settings.tracking ? 'granted' : 'denied',
            'functionality_storage': this.settings.functional ? 'granted' : 'denied',
            'personalization_storage': this.settings.tracking ? 'granted' : 'denied',
            'security_storage': this.settings.functional ? 'granted' : 'denied',
        }

        this.cookies.set(this.options.cookies.name, JSON.stringify(this.settings), { expires: this.options.cookies.lifetime });
        this.cookies.set(this.options.cookies.google_consent_name, JSON.stringify(consentSettings));

        this.onConsentChange(consentSettings);
    }

    saveUserPreferences() {
        let settings = {};

        for (var setting in this.options.settings) {
            settings[setting] = (document.getElementById('dbk-cookie-' + setting + '-cb').checked) ? 1 : 0;
        }

        this.setSettings(settings);
        this.saveSettings();
    }

    initCookieMessage() {
        // inject cookie html into <body>
        this.template = document.getElementById('dbk-cookie-bar-template');
        document.body.insertAdjacentHTML('beforeend', this.template.innerHTML);

        // elements
        const element = document.getElementById(this.options.elementId),
            form = document.getElementById('dbk-cookie-message-form'),
            tabs = document.querySelectorAll('.dbk-cookies [data-dbk-go-to-tab]'),
            tabPanels = document.querySelectorAll('.dbk-cookies .dbk-tab-panel'),
            checkBoxes = document.querySelectorAll('.dbk-cookies .dbk-cookie-setting-checkbox'),
            allowButton = document.querySelector('.dbk-cookies__footer .dbk-btn--allow-all');

        const saveAndClose = () => {
            this.saveUserPreferences();
            document.body.removeChild(element);
        }

        // save settings on submit
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            saveAndClose();
        });

        // check all checkboxes and submit
        allowButton.addEventListener('click', (event) => {
            event.preventDefault();
            checkBoxes.forEach(checkbox => {
                checkbox.checked = true;
            })
            saveAndClose();
        })

        // tabs
        tabs.forEach(tab => {
            tab.addEventListener('click', (event) => {
                let tabid = event.currentTarget.getAttribute('data-dbk-go-to-tab');

                // reset state for all tabs (inactive)
                tabs.forEach(tab => {
                    tab.setAttribute('data-state', '');
                });

                tabPanels.forEach(tabPanel => {
                    tabPanel.setAttribute('data-state', '');
                })

                // set active state for selected tab
                document.querySelector('.dbk-cookies .dbk-tab[data-dbk-go-to-tab="' + tabid + '"]').setAttribute('data-state', 'active');

                // set visible state for selected tab panel
                document.querySelector('.dbk-cookies .dbk-tab-panel[data-dbk-tab-id="' + tabid + '"]').setAttribute('data-state', 'visible');

                // show/hide correct buttons
                let buttonEdit = document.querySelector('.dbk-cookies .dbk-btn--edit-preferences'),
                    buttonSaveSelection = document.querySelector('.dbk-cookies .dbk-btn--save-selection');

                if (buttonEdit && buttonSaveSelection) {
                    if ('settings' === tabid) {
                        buttonEdit.style.display = 'none';
                        buttonSaveSelection.style.display = 'block';
                    } else {
                        buttonEdit.style.display = 'block';
                        buttonSaveSelection.style.display = 'none';
                    }
                }
            });
        });

    }
}

window.cookieMessage = new CookieMessage();

